// extracted by mini-css-extract-plugin
module.exports = {"label":"EKqtn1wKBQV00lLAWqdda","active":"_1tQm104RHflc8H6wqpEWUA"};